import React from 'react';
import moment from 'moment';
import { constants } from '../../../constants/constants';
import dateTimeUtils from '../../../utils/dateTime.utils';
import { SameDayBwicIcon } from '../../common/SameDayBwicIcon';
import { BwicRulesSectionRow } from './BwicRulesSectionRow';
import { GoodUntilTime } from '../../common/bidding/GoodUntilTime';

interface BwicRulesStartEndTimeProps {
    bidDueUtc: Date;
    goodUntilUtc: Date;
    isSameDayBwic: boolean;
    daysToSettle: number;
}

export function BwicRulesStartEndTime({ bidDueUtc, goodUntilUtc, isSameDayBwic, daysToSettle }: BwicRulesStartEndTimeProps) {
    const bwicDate = moment().isSame(bidDueUtc, 'd') ?
        `Today, ${dateTimeUtils.utcToLocalString(bidDueUtc, constants.dateFormat)}` :
        dateTimeUtils.utcToLocalString(bidDueUtc, `ddd, ${constants.dateFormat}`);

    return (
        <div className="rules-section">
            <div className="rules-section-title">
                <h4>BWIC Date</h4>
                <div className="rules-value flex-item-right text-left">
                    {isSameDayBwic && <SameDayBwicIcon />}
                    {bwicDate}
                </div>
            </div>
            <div className="rules-section-content">
                <BwicRulesSectionRow label='Start time' dataTestId='start-time'>
                    {dateTimeUtils.utcToLocalString(bidDueUtc, constants.timeFormat)}
                </BwicRulesSectionRow>
                <BwicRulesSectionRow label='End time' dataTestId='end-time'>
                    {dateTimeUtils.utcToLocalString(goodUntilUtc, constants.timeFormat)}
                </BwicRulesSectionRow>
                <BwicRulesSectionRow label='Bids good until' dataTestId='bids-good-until'>
                    <GoodUntilTime goodUntilUtc={goodUntilUtc} />
                </BwicRulesSectionRow>
                <BwicRulesSectionRow label='Settlement' dataTestId='settlement'>
                    {`T+${daysToSettle}`}
                </BwicRulesSectionRow>
            </div>
        </div>
    )
}
